module.exports = __webpack_public_path__ + "static/media/marani.e58d33ca.jpg";